// extracted by mini-css-extract-plugin
module.exports = {"addRound":"AddRound_addRound__GfzGs","submitRound":"AddRound_submitRound__2lgqX"};